import {DateAdapter, MAT_DATE_FORMATS} from "@angular/material/core";
import {CustomMonthAndYearDateAdapter} from "../../adapters/custom-month-and-year.adapter";
import {CUSTOM_MONTH_YEAR_FORMAT} from "../formats/custom-date.format";

export const customMonthYearProvider = [
  {
    provide: DateAdapter,
    useClass: CustomMonthAndYearDateAdapter,
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: CUSTOM_MONTH_YEAR_FORMAT
  }
]
